import React, {Fragment, useEffect, useState} from 'react';

import {useFilePicker} from 'use-file-picker';

import PropTypes from "prop-types";

import './SingleFilePicker.scss' ;

const SingleFilePicker = (props) =>
{
    const {openFilePicker, filesContent, loading, errors, plainFiles, clear} = useFilePicker({
        multiple: false,
        readAs: 'DataURL', // availible formats: "Text" | "BinaryString" | "ArrayBuffer" | "DataURL"
        accept: ['.doc', '.pdf', '.docx', '.jpg', '.png'],
        maxFileSize: 20, // Mb
        readFilesContent: true, // ignores file content
    });

    useEffect(() =>
    {
        if ( filesContent.length > 0 )
        {
            console.log ( "Content Changed") ;
            console.log ( filesContent );

            props.onChange ( filesContent ) ;
        }
    }, [filesContent]);

    return (
        <Fragment>

            <div ref={props.inputRef} className='picker-row'>
                <button name={props.name} type='button' onClick={() => openFilePicker()}>Select file</button>
                {plainFiles.map(file => (
                    <div key={file.name}>{file.name}</div>
                ))}
            </div>

            {errors !== null && errors.length > 0 && errors[0].fileSizeTooSmall && 'File size is too small!'}
            {errors !== null && errors.length > 0 && errors[0].fileSizeToolarge && 'File size is too large!'}
            {errors !== null && errors.length > 0 && errors[0].readerError && 'Problem occurred while reading file!'}
            {errors !== null && errors.length > 0 && errors[0].maxLimitExceeded && 'Too many files'}
            {errors !== null && errors.length > 0 && errors[0].minLimitNotReached && 'Not enough files'}

        </Fragment>
    )
}

export default SingleFilePicker;

SingleFilePicker.defaultProps =
    {}

SingleFilePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
};